import { SearchableCombobox, TSearchable } from '../../base/combobox'
import { useCombobox } from '@/helpers/useCombobox'
import { CustomFieldField } from '@/types'

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}
interface CustomFieldFieldItem {
  id: CustomFieldField
  name: string
  detail: string
}

const values: CustomFieldFieldItem[] = [
  { id: CustomFieldField.Boolean, name: 'Boolean', detail: 'A yes or no' },
  // { id: CustomFieldField.Select, name: 'Select', detail: 'Pick from a list of set options' },
  { id: CustomFieldField.Text, name: 'Text', detail: 'Free-for-all input' },
]

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { items } = useCombobox<CustomFieldFieldItem>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: values,
    buildSearchable: item => item
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={false}
      moreToFetch={false}
      refetch={() => {}}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      onChange={onChange}
    />
  )
}
